import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http'; // ✅ ต้อง import
import {
  UserSetting,
  UserSettingPayload,
} from '../../../../../core/models/user.model';
import { StatusAPIResponse } from '../../../../../core/models/information.model';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiUserService } from '../../../../../core/services/api/User/api-user';
@Component({
  selector: 'app-setting',
  imports: [CommonModule, FormsModule, PssLoadingComponent],
  templateUrl: './setting.component.html',
  styleUrl: './setting.component.css',
})
export class SettingComponent {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;
  userSetting: UserSetting | null = null;
  isLoading: boolean = false;
  isEnglish: boolean = false;
  notifyIn: boolean = false;
  notifyOut: boolean = false;
  isRequestTax: boolean = false;
  notifyExpire: boolean = false;
  selectedLang: 'TH' | 'EN' = 'TH';
  token: string = '';
  uid: string = '';
  appVersion = '0.0.0';

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''


  constructor(
    private cookieService: CookieService,
    private apiUserService: ApiUserService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private languageService: LanguageService,
    private http: HttpClient
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
    this.toast = toast;
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    // console.log(this.uid);
    this.checkAppVersion();
    setTimeout(() => {
      this.getUserSetting();
    }, 200);
  }

  checkAppVersion(): void {
    this.http
      .get<{ version: string }>('./version.json', {
        headers: { 'Cache-Control': 'no-cache' },
      })
      .subscribe((response) => {
        const currentVersion = localStorage.getItem('app_version');
        this.appVersion = currentVersion || '';
      });
  }
  /* -------------------------------------- Function -------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }

  /* --- Function --- */
  getUserSetting() {
    this.isLoading = true;
    this.apiUserService.GetUsersetting(this.token, this.uid).subscribe({
      next: (response: UserSetting) => {
        this.isLoading = false;
        // console.log('date :', response);
        if (response) {
          this.userSetting = response;
          this.notifyIn = this.userSetting.alertEntry;
          this.notifyOut = this.userSetting.alertExit;
          this.notifyExpire = this.userSetting.alertExpire;
          const langFromDb: string = this.userSetting.language;

          if (langFromDb === 'TH' || langFromDb === 'EN') {
            this.setLang(langFromDb);
          }
        } else {
          console.error('API error:', 'No Data');
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  updateUserSetting() {
    this.isLoading = true;
    const payload: UserSettingPayload = {
      alertEntry: this.notifyIn,
      alertExit: this.notifyOut,
      alertExpire: this.notifyExpire,
      language: this.selectedLang,
      uid: this.uid,
    };
    if (payload) {
      console.log(payload);
      this.apiUserService.UpdateUserSetting(payload, this.token).subscribe({
        next: (response: StatusAPIResponse) => {
          this.isLoading = false;
          console.log('📦 Response:', response);
          if (response.code == '000') {
            this.languageService.setLang(this.selectedLang);
            this.showSuccess(
              this.currentLang === 'TH' ? 'บันทึกสำเร็จ' : 'Saved successfully.'
            );
          } else {
            this.showError(
              this.currentLang === 'TH'
                ? 'บันทึกไม่สำเร็จ'
                : 'Save not successful.'
            );
          }
        },
        error: (err) => {
          console.error('❌  ไม่สำเร็จ:', err);
          this.showError(
            this.currentLang === 'TH'
              ? 'บันทึกไม่สำเร็จ'
              : 'Save not successful.'
          );
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    } else {
      console.log('No Payload');
    }
  }

  setLang(lang: 'TH' | 'EN') {
    this.selectedLang = lang;
    // 👇 เพิ่ม logic เปลี่ยนภาษาได้ตรงนี้
    console.log('🔁 เปลี่ยนภาษาเป็น', lang);
  }

  goback() {
    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 0);
  }
}
